<template>
  <shit-shell title="My Screen Size is...">
    <div class="grid cols-1">
      <div class="h-16 bg-teal-500 sm:bg-blue-500 md:bg-indigo-500 lg:bg-purple-500 xl:bg-pink-500"></div>
      <div class="col-span-1 mx-auto">
        <table class="table-auto">
          <thead>
            <tr>
              <th class="px-4 py-2">Color</th>
              <th class="px-4 py-2">Screen Size</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row sm:hidden">
              <td class="border px-4 py-2 bg-teal-500"></td>
              <td class="border px-4 py-2">Mobile</td>
            </tr>
            <tr class="hidden sm:table-row md:hidden">
              <td class="border px-4 py-2 bg-blue-500"></td>
              <td class="border px-4 py-2">Small</td>
            </tr>
            <tr class="hidden md:table-row lg:hidden">
              <td class="border px-4 py-2 bg-indigo-500"></td>
              <td class="border px-4 py-2">Medium</td>
            </tr>
            <tr class="hidden lg:table-row xl:hidden">
              <td class="border px-4 py-2 bg-purple-500"></td>
              <td class="border px-4 py-2">Large</td>
            </tr>
            <tr class="hidden xl:table-row">
              <td class="border px-4 py-2 bg-pink-500"></td>
              <td class="border px-4 py-2">Extra Large</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </shit-shell>
</template>

<script>
import ShitShell from '../components/ShitShell'

export default {
  components: {
    ShitShell
  }
}
</script>
